export { default } from './SimpleCarousel.vue';
